module.exports = __webpack_public_path__ + "static/media/calendar.cfc7c5a2.svg";